import React from "react";

const NUMBER = "918484048673";
const MESSAGE = "Hi Assisto4U team, I need some help.";

export const WhatsAppButton = () => (
  <a
    href={`https://wa.me/${NUMBER}?text=${encodeURIComponent(MESSAGE)}`}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-support-btn"
    aria-label="Chat with Assisto4U support on WhatsApp"
    title="WhatsApp support: +91 84840 48673"
    className="fixed right-4 bottom-24 lg:bottom-6 lg:right-6 z-[60] w-14 h-14 rounded-full flex items-center justify-center shadow-lg transition-transform duration-200 hover:scale-110 active:scale-95"
    style={{ background: "#25D366", boxShadow: "0 8px 24px rgba(37,211,102,0.4)" }}
  >
    <svg viewBox="0 0 32 32" width="28" height="28" fill="#fff" aria-hidden="true">
      <path d="M16.003 3C8.82 3 3 8.82 3 16c0 2.29.6 4.53 1.74 6.5L3 29l6.68-1.75A12.94 12.94 0 0 0 16.003 29C23.18 29 29 23.18 29 16S23.18 3 16.003 3zm0 23.6c-2.03 0-4.02-.55-5.75-1.58l-.41-.24-3.96 1.04 1.06-3.86-.27-.43A10.57 10.57 0 0 1 5.4 16c0-5.85 4.76-10.6 10.6-10.6 5.85 0 10.6 4.75 10.6 10.6 0 5.85-4.75 10.6-10.6 10.6zm5.81-7.94c-.32-.16-1.88-.93-2.17-1.03-.29-.11-.5-.16-.71.16-.21.32-.82 1.03-1 1.24-.18.21-.37.24-.69.08-.32-.16-1.34-.49-2.55-1.57-.94-.84-1.58-1.88-1.76-2.2-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.18.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.71-.97-2.34-.26-.62-.52-.53-.71-.54h-.61c-.21 0-.56.08-.85.4-.29.32-1.11 1.09-1.11 2.65s1.14 3.08 1.3 3.29c.16.21 2.24 3.42 5.43 4.8.76.33 1.35.52 1.81.67.76.24 1.45.21 2 .13.61-.09 1.88-.77 2.14-1.51.27-.74.27-1.38.19-1.51-.08-.13-.29-.21-.61-.37z"/>
    </svg>
  </a>
);

export default WhatsAppButton;
